import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
    paper: {
      boxShadow: '0px 3px 6px #0000001A',
      border: '1px solid #E0E0E0',
      padding: 40,
    },

    userListItem: {
      display: 'inline-block',
      padding: '0 0 8px 0',
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    label: {
      color: '#4D4F5C',
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(13),
    },
    text: {
      marginLeft: '10px',
      color: '#777777',
      fontSize: theme.typography.pxToRem(13),
    },
    button: {
      padding: 0,
      textTransform: 'capitalize',
      fontSize: theme.typography.pxToRem(13),
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    primary: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(13),
    },
    secondary: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(13),
    },
  };
});

export { useStyles, listTextStyles };
